import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "custom-search" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-9" }
const _hoisted_6 = { class: "from-group" }
const _hoisted_7 = { class: "col-md-3" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = { class: "from-group" }
const _hoisted_10 = { class: "col-md-4" }
const _hoisted_11 = { class: "from-group" }
const _hoisted_12 = { class: "col-md-4" }
const _hoisted_13 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_14 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_15 = { class: "custom-search" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-md-9" }
const _hoisted_18 = { class: "from-group" }
const _hoisted_19 = { class: "col-md-3" }
const _hoisted_20 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_21 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_22 = { class: "custom-search" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-md-9" }
const _hoisted_25 = { class: "from-group" }
const _hoisted_26 = { class: "col-md-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "card-header" }, [
        _createElementVNode("h3", null, "Nouvelle reception ( CLIENT )")
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _cache[9] || (_cache[9] = _createElementVNode("label", null, "Code Suivi :", -1)),
                _withDirectives(_createElementVNode("input", {
                  placeholder: "Code Suivi",
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.codeColis) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.codeColis]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary mt-3",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.getCstmr && _ctx.getCstmr(...args)))
              }, _cache[10] || (_cache[10] = [
                _createElementVNode("i", { class: "flaticon-search" }, null, -1)
              ]))
            ]),
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "col-md-12" }, [
              _createElementVNode("hr")
            ], -1)),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[12] || (_cache[12] = _createElementVNode("label", null, "Store:", -1)),
                _createVNode(_component_v_select, {
                  options: _ctx.clientsList,
                  class: "custom-select-height",
                  modelValue: _ctx.cstmrColi,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.cstmrColi) = $event)),
                  label: "magasin_name",
                  onSearch: _ctx.onSearchClients
                }, {
                  "no-options": _withCtx(() => _cache[11] || (_cache[11] = [
                    _createTextVNode(" Taper un mot pour chercher un store ", -1)
                  ])),
                  option: _withCtx((option) => [
                    _createElementVNode("span", null, _toDisplayString(option.magasin_name) + " - " + _toDisplayString(option.nb_colis) + " (Colis)", 1)
                  ]),
                  _: 1
                }, 8, ["options", "modelValue", "onSearch"])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[13] || (_cache[13] = _createElementVNode("label", null, "Agence:", -1)),
                _createVNode(_component_v_select, {
                  class: "custom-select-height",
                  label: "name",
                  options: _ctx.agencyList,
                  placeholder: "Agence",
                  modelValue: _ctx.agency,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.agency) = $event))
                }, null, 8, ["options", "modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              (_ctx.auth.can('ADD_RECEPTION'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-outline-primary mt-3",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addCstmrColi && _ctx.addCstmrColi(...args)))
                  }, " Ajouter "))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "card-header" }, [
        _createElementVNode("h3", null, "Nouvelle reception ( GLOBAL )")
      ], -1)),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _cache[16] || (_cache[16] = _createElementVNode("label", null, "Agence :", -1)),
                _createVNode(_component_v_select, {
                  class: "custom-select-height",
                  label: "name",
                  modelValue: _ctx.gobalAgency,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.gobalAgency) = $event)),
                  options: _ctx.agencyList,
                  placeholder: "Agence"
                }, null, 8, ["modelValue", "options"])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              (_ctx.auth.can('ADD_RECEPTION'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-outline-primary mt-3",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.addGlobalNote && _ctx.addGlobalNote(...args)))
                  }, " Ajouter "))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _cache[19] || (_cache[19] = _createElementVNode("div", { class: "card-header" }, [
        _createElementVNode("h3", null, "Nouvelle reception ( STOCK )")
      ], -1)),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _cache[18] || (_cache[18] = _createElementVNode("label", null, "Agence :", -1)),
                _createVNode(_component_v_select, {
                  label: "stock_agency_name",
                  class: "custom-select-height",
                  modelValue: _ctx.stockAgency,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.stockAgency) = $event)),
                  options: _ctx.agencyStockList,
                  placeholder: "Agence"
                }, {
                  option: _withCtx((option) => [
                    _createElementVNode("span", null, _toDisplayString(option.stock_agency_name) + " - " + _toDisplayString(option.nb_colis) + " Colis", 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "options"])
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              (_ctx.auth.can('ADD_RECEPTION'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-outline-primary mt-3",
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.addStockNote && _ctx.addStockNote(...args)))
                  }, " Ajouter "))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ], 64))
}